function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  .st0{fill:#69D3A7;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n ");

var _ref3 = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
  xmlns: "ns_sfw;"
}, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
  bottomLeftOrigin: "true",
  height: 48,
  width: 119,
  x: 140.8,
  y: -224.2
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.9,30.4C0.3,28.3,0,26.2,0,24C0,14.2,6.2,5.2,15.4,1.6l1.2,3.1C8.7,7.8,3.3,15.5,3.3,24 c0,1.9,0.2,3.7,0.7,5.5L0.9,30.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M42.5,14.5C38.9,7.6,31.8,3.3,24.1,3.3c-2.7,0-5.4,0.5-7.9,1.6l-1.3-3.1c2.9-1.2,6-1.8,9.2-1.8 c9,0,17.2,5,21.4,12.9L42.5,14.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M16.9,19c1.9,0,3.5,1,4.3,2.8l0.1,0.1l3.3-1.1l-0.1-0.2c-1.3-3.1-4.2-5-7.6-5c-2.4,0-4.4,0.8-6,2.4 c-1.6,1.6-2.4,3.6-2.4,5.9c0,2.3,0.8,4.3,2.4,5.9c1.6,1.6,3.6,2.4,6,2.4c3.4,0,6.3-1.9,7.6-5l0.1-0.2l-3.3-1.1l-0.1,0.1 c-0.7,1.8-2.3,2.8-4.3,2.8c-1.4,0-2.5-0.5-3.4-1.4c-0.9-0.9-1.4-2.1-1.4-3.5c0-1.4,0.5-2.6,1.4-3.6C14.4,19.5,15.5,19,16.9,19z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M57.1,18.1c-1.5-1.6-3.4-2.4-5.6-2.4c-2.2,0-4,0.8-5.4,2.3v-2h-3.5V38h3.5v-8.1c1.4,1.5,3.2,2.3,5.4,2.3 c2.2,0,4.1-0.8,5.6-2.4c1.5-1.6,2.2-3.5,2.2-5.8C59.3,21.7,58.6,19.7,57.1,18.1z M54.3,27.5c-0.9,0.9-2,1.4-3.4,1.4 c-1.4,0-2.5-0.5-3.4-1.4c-0.9-0.9-1.4-2.1-1.4-3.5c0-1.4,0.5-2.6,1.4-3.6c0.9-0.9,2-1.4,3.4-1.4c1.4,0,2.5,0.5,3.4,1.4 c0.9,0.9,1.3,2.1,1.3,3.6C55.7,25.4,55.2,26.6,54.3,27.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M65,18v-1.9h-3.5v15.8H65V23c0-1.4,0.6-2.5,1.7-3.3c1.1-0.7,2.5-0.9,4.1-0.4l0.2,0.1V16L71,16 C68.7,15.4,66.5,16.2,65,18z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M80.3,15.8c-2.3,0-4.3,0.8-5.9,2.4C72.8,19.7,72,21.7,72,24c0,2.3,0.8,4.3,2.4,5.9c1.6,1.6,3.6,2.4,6,2.4 c3.3,0,6.1-1.7,7.5-4.4l0.1-0.2l-3-1.3l-0.1,0.1c-0.9,1.7-2.5,2.7-4.4,2.7c-2.5,0-4.4-1.5-4.9-3.9h12.8l0-0.2 c0.3-2.6-0.4-4.8-2-6.6C84.9,16.7,82.8,15.8,80.3,15.8z M75.7,22.4c0.6-2.2,2.4-3.5,4.5-3.5c2.2,0,4,1.4,4.6,3.5H75.7z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M97.8,22.5c-1.9-0.4-3.6-0.7-3.6-2c0-1.1,1.1-1.8,2.7-1.8c1.8,0,2.8,0.8,3,2.3l0,0.2l3.5-0.7l0-0.2 c-0.5-2.8-3-4.5-6.5-4.5c-1.8,0-3.3,0.5-4.5,1.4c-1.2,0.9-1.8,2.1-1.8,3.5c0,2.1,1.3,3.6,3.5,4.1c0.6,0.1,1.2,0.2,1.8,0.3 c2.2,0.4,4.2,0.8,4.2,2.2c0,1.1-1.3,1.9-3.2,1.9c-1.9,0-3-0.8-3.2-2.3l0-0.2l-3.5,0.7l0,0.2c0.5,2.8,3,4.5,6.8,4.5 c1.9,0,3.5-0.5,4.8-1.4c1.3-0.9,2-2.1,2-3.5C103.7,23.6,100.5,23,97.8,22.5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M113.1,22.5c-1.9-0.4-3.6-0.7-3.6-2c0-1.1,1.1-1.8,2.7-1.8c1.8,0,2.8,0.8,3,2.3l0,0.2l3.5-0.7l0-0.2 c-0.5-2.8-3-4.5-6.5-4.5c-1.8,0-3.3,0.5-4.5,1.4c-1.2,0.9-1.8,2.1-1.8,3.5c0,2.1,1.3,3.6,3.5,4.1c0.6,0.1,1.2,0.2,1.8,0.3 c2.2,0.4,4.2,0.8,4.2,2.2c0,1.1-1.3,1.9-3.2,1.9c-1.9,0-3-0.8-3.2-2.3l0-0.2l-3.5,0.7l0,0.2c0.5,2.8,3,4.5,6.8,4.5 c1.9,0,3.5-0.5,4.8-1.4c1.3-0.9,2-2.1,2-3.5C119,23.6,115.7,23,113.1,22.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M37.3,16.1l-4.6,11.8L28,16.1h-3.8l6.6,16.1L26,43.4l3.3,0.7l11.5-28H37.3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M26.6,42l-0.8,2c-0.2,0.4-0.5,0.7-0.9,0.7c-0.3,0-0.6,0-0.8,0c-9.6,0-18.1-6.8-20.2-16.1l-3.3,0.7 c1.2,5.2,4.1,10,8.3,13.4C13.2,46.1,18.5,48,24,48c0,0,0,0,0,0c0.3,0,0.6,0,1,0c1.7-0.1,3.3-1.1,3.9-2.7l1.1-2.6L26.6,42z"
});

var SvgCypress = function SvgCypress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "ns_extend;",
    i: "ns_ai;",
    graph: "ns_graphs;",
    xlink: "http://www.w3.org/1999/xlink",
    height: 60,
    viewBox: "0 0 119 48",
    style: {
      enableBackground: "new 0 0 119 48"
    },
    space: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.5674,
    y1: -144.8317,
    x2: 145.8324,
    y2: -164.3534,
    gradientTransform: "matrix(1 0 0 -1 -106 -146.3902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0939,
    style: {
      stopColor: "#58D09E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9883,
    style: {
      stopColor: "#58D09E",
      stopOpacity: 0
    }
  })), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.7449,
    y1: -181.3066,
    x2: 140.6394,
    y2: -190.5943,
    gradientTransform: "matrix(1 0 0 -1 -106 -146.3902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0774,
    style: {
      stopColor: "#58D09E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7617,
    style: {
      stopColor: "#1B1E2E"
    }
  })), _ref13));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCypress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cypress.fa333016.svg";
export { ForwardRef as ReactComponent };